<template>
  <ClientOnly>
    <VList ref="list" endpoint="reviews" :params="{ variables }" :per-page="1">
      <template #loading>
        <div class="space-y-4">
          <ShimmerReview />
          <ShimmerReview />
          <ShimmerReview />
          <ShimmerReview />
        </div>
      </template>
      <template #loading-page>
        <div class="space-y-4">
          <ShimmerReview />
          <ShimmerReview />
          <ShimmerReview />
          <ShimmerReview />
        </div>
      </template>

      <template #default="response">
        <div class="space-y-4 dark:bg-gray-850">
          <!-- 
          Ask for Review only if first review is not by user
          The API returns the first review of user if the user has added review.
         -->
          <StoreProductReview
            v-if="
              isLoggedIn &&
              response.items &&
              response.items[0] &&
              response.items[0].customer?.id !== authUserId
            "
            class="p-6 border rounded-lg"
            @refresh="refresh()"
          />
          <StoreReview
            v-for="item in response.items"
            :key="item.id"
            :data="item"
            :is-author="item?.customer?.id === authUserId"
            @refresh="refresh()"
          />
        </div>

        <div class="flex justify-center p-8">
          <VListLoadMore>
            <template #default="{ loading, loadMore }">
              <VyButton
                :loading="loading"
                color="primary"
                theme="solid"
                shape="rounded"
                size="lg"
                :label="$t('load_more')"
                @click="loadMore()"
              />
            </template>
            <template #end> — {{ $t("list-thats-all") }} — </template>
          </VListLoadMore>
        </div>
      </template>

      <template #empty>
        <StoreProductReview
          v-if="isLoggedIn"
          class="p-6 border rounded-lg"
          @refresh="refresh()"
        />
        <div v-else />
      </template>
    </VList>
  </ClientOnly>
</template>

<script>
/**
 * TODO // Backend will provide contact data even after it is deleted.
 * Customer Data can be null if contact is deleted. Handle it carefully for showing reviews.
 */

import { mapState } from "pinia";
import { useVepaarStore } from "@/store/store.js";
import { useProductStore } from "@/store/product.js";
import { useAuthStore } from "@/store/auth";

export default {
  computed: {
    ...mapState(useProductStore, ["id"]),
    ...mapState(useVepaarStore, ["hash"]),
    ...mapState(useAuthStore, ["authUserId", "isLoggedIn"]),
    variables() {
      return {
        hash: this.hash,
        productId: this.id,
      };
    },
  },

  methods: {
    refresh() {
      const { clients } = useApollo();
      clients.default.cache.evict({
        id: "ROOT_QUERY",
        fieldName: "productReviews",
      });
      clients.default.cache.evict({
        id: "ROOT_QUERY",
        fieldName: "productReview",
      });
      this.$refs.list.refresh();
    },
  },
};
</script>
